export const getOffers = state => state.transporeonOffers.getIn(['all', 'objects'])
export const getOffersLoading = state => state.transporeonOffers.getIn(['all', 'fetching'])

export const getAcceptInProgress = state => state.transporeonOffers.getIn(['accept', 'inProgress'])
export const getAcceptError = state => state.transporeonOffers.getIn(['accept', 'error'])

export const getDeclineInProgress = state => state.transporeonOffers.getIn(['decline', 'inProgress'])
export const getDeclineError = state => state.transporeonOffers.getIn(['decline', 'error'])
